'use client'

import { useEffect, useState } from "react";
import { FaQuoteLeft } from "react-icons/fa6";


import { getQuote } from '@/utils/functions';
import { usePathname } from "next/navigation";
type QuoteProps = {
    locale: string
};

export const Quote = ({ locale }: QuoteProps) => {

    const [randomQuote, setRandomQuote] = useState<any>(null);

    const pathname = usePathname();
    useEffect(() => {
        setRandomQuote(getQuote(locale));
    }, [pathname])

    return (
        <footer className="mt-5 lg:mt-0 px-8 lg:h-25vh flex flex-col justify-center">
            <div className="flex">
                <FaQuoteLeft className="text-primaryBlue700 text-2xl mr-2" />
                <div>
                    <div className="mb-3">{randomQuote?.quote}</div>
                    <div className="font-bold  text-primaryBlue950 text-md font-fraunces italic">{randomQuote?.author}</div>
                </div>
            </div>
        </footer>
    );
};
